module.exports = __webpack_public_path__ + "img/mark-myfolder-new.4f43568.svg";